import PasswordInputWrapper from './index.style';

export default PasswordInputWrapper;
